import { useStorage } from '@vueuse/core'

export default () => {
  const activeWorkspaceId = useStorage('auth-active-account-id', '')
  watch(activeWorkspaceId, (newValue, oldValue) => {
    if (newValue && oldValue)
      window.location.reload()
  })
}
